(() => {
  if (customElements.get('millesimes-admin-content')) return;
  class MillesimesAdminContent extends HTMLElement {
    connectedCallback() {
      this.content = JSON.parse(this.querySelector('[data-admin-content]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-admin-variants]').textContent);
      const fallback = this.querySelector('[data-admin-fallback]');
      this.fallback = fallback ? JSON.parse(fallback.textContent) : '';
      this.onVariant = (event) => {
        const detail = event.detail || {};
        const productId = detail.data?.productId;
        if (productId && String(productId).split('/').pop() !== this.dataset.productId) return;
        const variant = detail.resource;
        if (variant && Object.prototype.hasOwnProperty.call(this.variants, String(variant.id))) this.render(String(variant.id));
      };
      document.addEventListener('variant:update', this.onVariant);
    }
    disconnectedCallback() { document.removeEventListener('variant:update', this.onVariant); }
    localized(value) { return value?.[this.dataset.locale] || value?.fr || value?.en || ''; }
    render(variantId) {
      const sku = this.variants[variantId];
      const content = this.content.skus[sku] || { description: {}, category_ids: [] };
      const root = this.querySelector('[data-admin-rendered]');
      const fragment = document.createDocumentFragment();
      const body = this.localized(content.description);
      if (body) {
        const holder = document.createElement('div');
        holder.className = 'millesimes-admin-description';
        // The sync renders plain admin text as paragraphs and line breaks.
        // Restrict parsing to those tags even if a metafield is edited directly.
        const template = document.createElement('template');
        template.innerHTML = body;
        const safe = (node) => {
          if (node.nodeType === Node.TEXT_NODE) return document.createTextNode(node.textContent);
          const result = document.createElement(node.nodeName === 'BR' ? 'br' : 'p');
          if (node.nodeName !== 'BR') {
            for (const child of node.childNodes) {
              if (child.nodeType === Node.TEXT_NODE || child.nodeName === 'BR') result.append(safe(child));
              else result.append(document.createTextNode(child.textContent || ''));
            }
          }
          return result;
        };
        for (const node of template.content.childNodes) holder.append(safe(node));
        fragment.append(holder);
      } else if (this.fallback) {
        // No admin description for this SKU: fall back to the native product
        // description, trusted HTML already rendered as-is by the Liquid side.
        const holder = document.createElement('div');
        holder.className = 'millesimes-admin-description';
        holder.innerHTML = this.fallback;
        fragment.append(holder);
      }
      for (const id of content.category_ids) {
        const category = this.content.categories[id];
        if (!category) continue;
        const section = document.createElement('section');
        section.className = 'millesimes-admin-category';
        section.dataset.categoryId = String(category.id);
        const heading = document.createElement('h3');
        heading.textContent = category.name;
        section.append(heading);
        for (const detail of category.details) {
          const title = this.localized(detail.title);
          if (title) { const h = document.createElement('h4'); h.textContent = title; section.append(h); }
          const paragraph = document.createElement('p');
          paragraph.className = 'millesimes-admin-text';
          paragraph.textContent = this.localized(detail.value);
          section.append(paragraph);
        }
        fragment.append(section);
      }
      root.replaceChildren(fragment);
      this.dataset.variantId = variantId;
    }
  }
  customElements.define('millesimes-admin-content', MillesimesAdminContent);
})();
